import { Component, Output, OnInit, Input, ViewEncapsulation, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ToggleSwitchComponent implements OnInit {
  @Input() name: string;
  @Input() disabled: boolean;
  @Input() value: boolean;
  @Output() valueChange = new EventEmitter<boolean>();
  @Output() saveModel = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onChange(): void {
    this.valueChange.emit(this.value);
  }

  onSaveModel(): void {
    this.valueChange.emit(this.value);
    this.saveModel.emit();
  }

  setDisabled(flag: boolean): void {
    this.disabled = flag;
  }
}
